import { OrgType } from '@sennder/senn-node-microfrontend-interfaces'
import { UserAccessHandler } from '@sennder/shell-utilities'

import { getStateData } from '@/store'
import { featureFlag } from '@/services/featureFlagProvider'

/**
 * Access handlers are functions which return a boolean. They can be used as menu visibility handlers, and called in route guards.
 *
 * NAMING CONVENTIONS
 *
 * Access handler name should be a sentence which describes what access it checks, or user role it checks.
 *
 * - userIs{Role}: Check if the user has a specific role
 * - canAccess{Page}: Check if the user has access to the page
 */

export const canAccessCharteringPages = ((org = getStateData().org) => {
  return !!(org?.orgType === OrgType.CHARTERING_OFFICE)
}) satisfies UserAccessHandler

export const canAccessShipperContactsPages: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('enable-shipper-contacts-mfs')

export const canAccessTransportAnalysis: UserAccessHandler = () => {
  return !!featureFlag.getFeatureFlag('DISPLAY_TRANSPORT_ANALYSIS')
}

export const canAccessCustomerDataPages: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('enable-customer-data-mfs')

export const canAccessTenderingPages: UserAccessHandler = () =>
  !!featureFlag.getFeatureFlag('enable-tendering-mf-component')
